/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { GDSTextActionProps, TextAction } from '@leagueplatform/genesis-core';
import { MasonryEngineNodeAction } from '@leagueplatform/masonry-engine';
import { getMasonryActionComponentSemantics } from '../../utils/get-masonry-action-component-semantics.util';

interface MasonryTextActionProps extends GDSTextActionProps<'a'> {
  action: MasonryEngineNodeAction | undefined;
}

/**
 * A wrapper around the Genesis TextAction component that helps with masonry renderers with correct semantics based on the action.
 */

export const MasonryTextAction = React.forwardRef<
  HTMLAnchorElement | null,
  MasonryTextActionProps
>((props: MasonryTextActionProps, ref) => {
  const { action, ...rest } = props;
  const masonryActionComponentSemantics = React.useMemo(
    () => getMasonryActionComponentSemantics({ action }),
    [action],
  );

  return (
    <TextAction {...masonryActionComponentSemantics} {...rest} ref={ref} />
  );
});
